module.exports = __webpack_public_path__ + "img/riwayat_lembur.2e4638b9.png";